import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import type { AlertBannerAction } from "@jti/core-components/components/AlertBanner";
import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui";

export const MagentoOrderCreationErrorView: FC = () => {
  const { __ } = useTranslations();
  const config = useConfig();
  const description =
    __("cart.checkout.exception.magento_order_creation_issue.message") +
    (config.CONTACT_US_URL ? __("cart.checkout.exception.magento_order_creation_issue.contact_us_message") : "");

  const handleSecondButtonClick = () => {
    window.open(config.CONTACT_US_URL, "_self");
  };

  const firstErrorAction: AlertBannerAction = {
    label: __("cart.checkout.exception.magento_order_creation_issue.action"),
    onClick: () => window.location.reload(),
  };

  const secondButtonAction: AlertBannerAction = {
    label: __("cart.checkout.exception.magento_order_creation_issue.contact_us_cta"),
    onClick: handleSecondButtonClick,
  };

  return (
    <AlertBanner
      description={description}
      tone="error"
      title={__("cart.checkout.exception.magento_order_creation_issue.title")}
      actions={config.CONTACT_US_URL ? [firstErrorAction, secondButtonAction] : [firstErrorAction]}
    />
  );
};
